const getItineraryData = async (endpoint, previewMode, itineraryData) => {
  const headers = {};
  if (previewMode) {
    headers["IsPreview"] = "1";
  }
  const response = await fetch(endpoint, { headers: headers });

  const data = await response.json();

  const mscConf = {
    cruiseTitle: itineraryData.cruiseTitle,
    price: itineraryData.price,
    upliftPrice: itineraryData.upliftPrice,
    portTax: itineraryData.portTax,
    fallbackImageDesktop: itineraryData.fallbackImageDesktop ?? "",
    fallbackImageMobile: itineraryData.fallbackImageMobile ?? "",
    ribbons: [],
  };

  data.ItineraryName = mscConf?.cruiseTitle;
  data.Price = mscConf.price;
  data.StartPrice = mscConf.upliftPrice;
  data.Tax = mscConf.portTax;
  data.Images ??= {};
  data.Images.Desktop ||= mscConf.fallbackImageDesktop;
  data.Images.Mobile ||= mscConf.fallbackImageMobile;
  data.UpliftPrice = mscConf.upliftPrice;
  data.Ribbons = mscConf.ribbons;

  return data;
};

const getLangData = async (endpoint, language, previewMode) => {
  const headers = {};
  if (previewMode) {
    headers["IsPreview"] = "1";
  }

  const response = await fetch(`${endpoint}?lang=${language}`, {
    headers: headers,
  });
  return await response.json();
};

export default {
  getItineraryData,
  getLangData,
};
